import { useTranslation } from '@dreamstack/i18n'
import { useMemo } from 'react'
import * as yup from 'yup'
import { useIsLoggedIn } from '../../../auth/src/lib/useIsLoggedIn'
import { useYupValidationResolver } from '../hooks/useYupValidationResolver'

export type AccessFileFormData = {
  clientEmail: string
  subscribeNewsletter: boolean
  consent: boolean
}

const useAccessFileFormYupObject = () => {
  const t = useTranslation()
  const isLoggedIn = useIsLoggedIn()
  const defaultSchema = useMemo(
    () => ({
      clientEmail: yup
        .string()
        .email(t('accentro:pleaseEnterAValidEmail'))
        .required(t('accentro:pleaseEnterAValidEmail')),

      consent: yup
        .boolean()
        .oneOf([true], t('accentro:generalForm.requiredConsentMessage')),

      subscribeNewsletter: yup.boolean(),
    }),
    [t]
  )
  const loggedInSchema = { subscribeNewsletter: yup.boolean() }
  return isLoggedIn ? loggedInSchema : defaultSchema
}

export const useAccessFileFormSchema = () => {
  const schema = useAccessFileFormYupObject()
  return useYupValidationResolver(yup.object(schema))
}
